import React from 'react';
import { BunkeringDateListWrapper } from './BunkeringDateList.styles';
import { AolGroup } from 'src/types/ViewModel/AolItem';
import BunkeringDateListItem from './BunkeringDateListItem';
import { isDateSame } from 'odfjell-date-time-utils/dateTimeUtils';

interface BunkeringDateListVisualProps {
    dates: Date[];
    onSelectCalendarDate: (date: Date) => void;
    aolGroups: AolGroup[];
    selectedBunkeringDate: Date;
}

const BunkeringDateListVisual: React.FC<BunkeringDateListVisualProps> = (props) => {
    return (
        <BunkeringDateListWrapper>
            {props.dates.map((date, index) => (
                <BunkeringDateListItem
                    key={index}
                    date={date}
                    aolGroup={props.aolGroups.find((aolGroup) => isDateSame(date, aolGroup.aolDate))}
                    onSelectCalendarDate={props.onSelectCalendarDate}
                    isSelected={isDateSame(date, props.selectedBunkeringDate)}
                ></BunkeringDateListItem>
            ))}
        </BunkeringDateListWrapper>
    );
};

export default BunkeringDateListVisual;
